import template from './columns-toggle.html';

class ColumnsToggleController {
  constructor() {
    'ngInject';
  }

  $onInit() {}
  resetSearch() {
    this.searchTerm = '';
  }

  toggleItemSelection(item) {
    const key = item?.key?.toLowerCase();
    if (key in this.selected) {
      delete this.selected[key];
      if (this.onDeselect) this.onDeselect({ key: key });
    } else {
      this.selected[key] = item;
      if (this.onSelect) this.onSelect({ key: key });
    }
  }
}

/**
 * items : items map {normalize key : {key,.....}]
 * selected :object map { key :item }
 */
export default {
  template,
  controller: ColumnsToggleController,
  controllerAs: 'vm',
  bindings: {
    items: '<',
    selected: '<',
    onSelect: '&',
    onDeselect: '&',
  },
};
